module.exports = __webpack_public_path__ + "static/media/YF22_4.9c1b3431.jpg";